<script>
  import {onMount, tick} from "svelte";
  import {Routes} from "./stores.js";
  import { fade } from 'svelte/transition';

  import {readable, writable} from 'svelte/store';

  import Logo from "./components/Logo.svelte";
  import Header from "./blocks/Header.svelte";
  import Footer from "./blocks/Footer.svelte";

  import Home from "./blocks/Home.svelte";
  import Brand from "./blocks/Brand.svelte";
  import Coffee from "./blocks/Coffee.svelte";
  import News from "./blocks/News.svelte";
  import Franchise from "./blocks/Franchise.svelte";
  import Menu from "./blocks/Menu.svelte";
  import Find from "./blocks/Find.svelte";
  import Inquiry from "./blocks/Inquiry.svelte";
  import Guide from "./blocks/Guide.svelte";
  import Blank from "./blocks/Blank.svelte";

  // const sleep = async time => new Promise(resolve => setTimeout(resolve, time * 1000));
  const BLOCK = {
    Home,
    Brand,
    Coffee,
    News,
    Franchise,
    Menu,
    Find,
    Inquiry,
    Guide,
    Blank,
  }

  let Component;
  const container_id = 'js-container';

  const blank = (heading, text) => {
    if (!heading && !text) {
      heading = '404 Page not found';
      text = '페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다.';
    }
    document.body.dataset.gnb = 'blank';
    document.body.dataset.lnb = 'blank';
    let target = document.getElementById(container_id);
    let props = {heading, text};
    return new BLOCK['Blank']({target, props});
  }

  const hashMatch = (hash, route) => {
    // console.group('hashMatch');
    let result = false;
    let route_hash = route.hash || route.href;
    let route_href = route.href;
    let keyword = route_hash && route_hash.slice(0, -1).replace(/\//g, '\\/');
    let regexr = str => Function(`"use strict"; return /^(?:${str})(.+)/g`)();

    if (route_hash === hash || route_href === hash) {
      result = true;
    } else if (keyword && route_hash.slice(-2) === '/*' && hash.match(regexr(keyword))) {
      result = true;
    }

    return result;
  }
  const scroll_top_limit = 130;
  // constant handleBodyScroll = async e => tick().then(() => document.body.dataset.scrollY = parseInt(window.scrollY));
  const handleBodyScroll = async e => tick().then(() => document.body.dataset.isScroll = window.scrollY >= (window.innerWidth > 500 ? scroll_top_limit : scroll_top_limit / 2) ? 'Y' : 'N');
  let resizeProc = false;
  const setViewHeight = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    resizeProc = false;
  }
  const handleResize = e => {
    if (!resizeProc) {
      window.requestAnimationFrame(setViewHeight);
      resizeProc = true;
    }
  };

  const handleHashChange = async e => {
    let gnb = false;
    let lnb = false;
    let default_hash = '/home';
    // let default_hash = '/ready';
    if (!location.hash || location.hash.slice(0, 1) === '#') {
      let hash = location.hash.slice(1) || default_hash;
      $Routes.forEach((route, i) => {
        // if(!route.hash) route.hash = route.href;
        route.class = [];
        gnb = hashMatch(hash, route) ? route : gnb;
        route.class.push('');
        if (route.child) {
          route.class.push('layout-header__gnb-item_has-lnb');
          route.child.forEach((route_child, i) => {
            // if(!route_child.hash) route_child.hash = route_child.href;
            route_child.class = [];
            route_child.class.push('');
            let match = hashMatch(hash, route_child);
            lnb = match ? route_child : lnb
            gnb = match ? route : gnb
          });
        }
      });

      gnb && gnb.class.push('layout-header__gnb-item_active');
      lnb && lnb.class.push('layout-header__lnb-item_active');

      // console.log(gnb, lnb);
      Routes.set([...$Routes]);
      document.body.dataset.gnb = gnb.href && gnb.href.slice(1) || '';
      document.body.dataset.lnb = lnb.href && lnb.href.slice(1) || '';

      let check = document.getElementById('gnb-btn-check');
      check.checked = false;
      window.scrollTo(0, 0);
    }

    const getBlockName = str => str ? str.slice(1).charAt(0).toUpperCase() + str.slice(2) : 'Home';
    try {
      let name = getBlockName(lnb.href || gnb.href);
      if (!lnb.href && !gnb.href && !name) throw new Error('404 Page not found');

      if (name === 'Ready') {
        Component && Component.$destroy();
        Component = blank('COMING SOON');
      } else {
        Component && Component.$destroy();
        Component = new BLOCK[name]({target: document.getElementById(container_id)});
        // Component = new Block({ target });
      }
    } catch (e) {
      Component && Component.$destroy();
      Component = blank();
    }
  }

  let loaded = false;
  const handleLoad = e => {
    handleResize(e);
    handleBodyScroll(e);
    handleHashChange(e);
    loaded = true;
  }

  import "./styles/brand.css";
  import "./styles/menu.css";
  import "./styles/franchise.css";
  import "./styles/coffee.css";
  import "./styles/find.css";
  import "./styles/inquiry.css";
  import "./styles/layout.css";
  import "./styles/components.css";
  import "./styles/common.css";
</script>

<svelte:window
  on:load={handleLoad}
  on:scroll={handleBodyScroll}
  on:hashchange={handleHashChange}
  on:resize={handleResize}
/>

{#if !loaded }
<div id="js-loading" class="loading" out:fade>
  <Logo class="white" />
</div>
{/if}

<Header/>

<main id="js-container" class="layout__main container"></main>

<div id="js-floating-banner" class="layout__floating"><a class="layout__floating-banner" href="#/inquiry"><i
  class="layout__floating-img"></i>창업문의</a></div>

<Footer/>
